import {
  isAfter,
  set,
  getHours,
  getMinutes,
} from "date-fns"
import _ from "lodash"

// test: jest src/models/__tests__/Form.model.spec.js
class Form {
  constructor (rawData) {
    this._rawData = rawData
  }

  requireCustomerRegistration() {
    return _.get(this._rawData, 'config.permissions', []).includes("registered")
  }

  isPublicAccessibleToCustomers() {
    return this.isInValidTimeRange() && this.isPublished()
  }

  isPublished() {
    return this._rawData.status === 'published'
  }

  routeNameAfterSubmission() {
    const nextPage = _.get(this._rawData, 'config.basic_setting.after_fill_out_show', null)
    return this._rawData.type === 'apply' && nextPage === 'confirm_page' ? 'LiffFormConfirm' : 'LiffFormThanks'
  }

  hasStarted() {
    const today = set(new Date(), {
      hours: String(getHours(new Date())).padStart(2, "0"),
      minutes: String(getMinutes(new Date())).padStart(2, "0"),
    })

    const startDate = set(new Date(this._rawData.start_at), {
      hours: String(getHours(new Date(this._rawData.start_at))).padStart(2, "0"),
      minutes: String(getMinutes(new Date(this._rawData.start_at))).padStart(2, "0"),
    })

    return !!this._rawData.start_at && isAfter(today, startDate)
  }

  hasEnded() {
    const today = set(new Date(), {
      hours: String(getHours(new Date())).padStart(2, "0"),
      minutes: String(getMinutes(new Date())).padStart(2, "0"),
    })

    const endDate = set(new Date(this._rawData.end_at), {
      hours: String(getHours(new Date(this._rawData.end_at))).padStart(2, "0"),
      minutes: String(getMinutes(new Date(this._rawData.end_at))).padStart(2, "0"),
    })

    return !!this._rawData.end_at && isAfter(today, endDate)
  }

  isInValidTimeRange() {
    return this.hasStarted() && false == this.hasEnded()
  }
}

export default Form
